

function UserInformation() {

    /// <summary>
    /// This object provides client-side functions for the Widget.Membership.UserInformation visual. <br/>
   /// <br/>
    /// Author: AFU<br />
    /// Date: 6.05.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 6.05.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.validation = null;
}
UserInformation.prototype = new vcTemplate();
UserInformation.prototype.init = function () {
    /// <summary>
    /// This function sets the input field values and inits the clickhandler and js-based input validation
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        
        me.validation = new vcFormValidation(me.visual, me.visual.find("#divBtnSave"));

        me.visual.find("#txtUsername").val(me.username);
        me.visual.find("#txtEmail").val(me.email);
        me.visual.find("#txtDescription").val(me.description);
        me.visual.find("#chbIsLockedOut").prop("checked", me.isLockedOut);
        me.visual.find("#chbIsDeleted").prop("checked", me.isDeleted);

        me.visual.find('#divBtnSave').button().off("click").on("click", function () { me.btnSave();});

        me.visual.find('.formItem .input').off("change, keyup").on("change, keyup", function () {
            me.validation.validate($(this).attr("id"), me.itemInfo[$(this).attr("id")]);
        });
        me.visual.find('.formItem .input').each(function () {
            me.validation.validate($(this).attr("id"), me.itemInfo[$(this).attr("id")]);
        });

        me.visual.find(".formItem :checkbox").off("click").on("click", function() { me.validation.checkValidState() });
      
        me.visual.find('#divBtnSave').button("disable");
        me.visual.find("#divIconSaved").hide();
        return true;
    } catch (ex) {
        me.writeError('init', ex);
        return false;
    }

};


UserInformation.prototype.btnSave = function () {
    /// <summary>
    /// Handles the click of the save button - first, it only checks the username <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        if (me.visual.find("#divBtnSave").button("option", "disabled")) {return false}
      
        var param = {}
        param.ID = me.ID;
        param.username = me.visual.find("#txtUsername").val();
        param.email = me.visual.find("#txtEmail").val();
        param.description = me.visual.find("#txtDescription").val();
        param.isLockedOut = me.visual.find("#chbIsLockedOut").prop("checked");
        param.isDeleted = me.visual.find("#chbIsDeleted").prop("checked");

        if (param.isDeleted && param.isLockedOut === false) {
            me.showInfo(me.resources.mustGetLocked, "", true);
            me.visual.find('#divBtnSave').button("disable");
            me.visual.find("#divIconSaved").hide();
            return false;
        }

        
        me.checkUsername(param);
        return true;
    } catch (ex) {
        me.writeError('btnSave', ex);
        return false;
    }
};


UserInformation.prototype.checkUsername = function (param) {
    /// <summary>
    /// Validates the username<br/>
    /// If everything is ok it saves the data.
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, "", "", me.deviceType, me.langid, JSON.stringify(param), function (result) {
         
            if (result === null) {
                me.showMessage(me.resources.err_loadData, true);
                return false;
            }
            if (result === false) {
                me.showInfo(me.resources.username_exists, "", true);
                
            } else {
                me.save(param);
            
          }
            return true;
        });
        return true;
    } catch (ex) {
        me.writeError('checkUsername', ex);
        return false;
    }
};


UserInformation.prototype.save = function (param) {
    /// <summary>
    /// Saves the data.<br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
       
       window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, "", "", me.deviceType, me.langid, JSON.stringify(param), function (result) {
           me.visual.find("#divIconSaved").show();
           me.visual.find('#divBtnSave').button("disable");
          
           if (result === null) {
               me.showMessage(me.resources.err_saveData, true);
               me.visual.find("#divIconSaved").hide();
               return false;
           }
           if (result === false) {
               me.showMessage(me.resources.err_saveData, true);
               me.visual.find("#divIconSaved").hide();
               return false;
           }
           me.showInfo("", "", false);
          
           return true;
        });
       return true;
    } catch (ex) {
        me.writeError('save', ex);
        return false;
    }
};

